const getRouteProtectionCode = () => {
  return `
    //Example:
    //If the user has permission to access 'DashboardLayout' the page will be displayed, else the user will be redirected to another page
     path: 'dashboard',
      element: (
        <AuthGuard roles={userPermissions.PORTAL}>
          <DashboardLayout />
        </AuthGuard>
      )
    `;
}

export default getRouteProtectionCode;
